export function LiveGameSeperator({  }) {
    return (
        <img className="w-[21px] h-[96px] -mx-3" src="/liveGameIcons/vertical_separator.png" alt=""/>
    )
}